export default __webpack_public_path__ + "static/media/filter.054ff40a.svg";